async function recommendationDrinksAPI() {
  const resolve = await fetch('https://www.thecocktaildb.com/api/json/v1/1/search.php?s=');
  const data = await resolve.json();
  return data.drinks;
}

export default recommendationDrinksAPI;
